import React, { useEffect, useMemo, useState, useCallback } from "react"
import { GAME_FACT_BASKET_FREETHROW, GAME_FACT_BASKET_THREEPOINTS, GAME_FACT_BASKET_TWOPOINTS, GAME_FACT_DROP, GAME_FACT_ESSAI, GAME_FACT_HANDBALL_GOAL, GAME_FACT_HANDBALL_PENALTY, GAME_FACT_PENALITE, GAME_FACT_SOCCER_BUT, GAME_FACT_SOCCER_PENALTY, GAME_FACT_SOCCER_SECONDYELLOWCARD, GAME_FACT_SOCCER_SHOT, GAME_FACT_SOCCER_YELLOWCARD, GAME_FACT_TRANSFORMATION } from "../gamefacts/types.js";
import { reasonListSoccer } from "../gamefacts/reasons.js";
import { getMediaNumericTimer, getNumericTimer, getPlayerById } from "../sports/genericUtils.js";
import { Box, Button, CircularProgress, Divider, Stack, Tab, Tabs, Typography, useMediaQuery } from "@mui/material";
import CompositionPreview from "../../../../components/Live/preview/composition/CompositionPreview.js";
import ItemResolver from "../items/ItemResolver.js";
import MatchHeader from "./header/MatchHeader.js";
import { useNavigate, useLocation } from "react-router-dom";
import CustomDivider from "../dsasComponents/CustomDivider.js";
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MatchView = ({ match, loadMore }) => {

    const navigate = useNavigate();
    const location = useLocation();

    // Options avancées & bouton custom
    const queryParams = new URLSearchParams(location.search);
    const redirectUrlFromUrl = queryParams.get('redirect-url');
    const displayTextFromUrl = queryParams.get('display-text');
    const buttonPositionFromUrl = queryParams.get('button-position') || 'top';

    const [pinItems, setPinItems] = useState([])

    const [items, setItems] = useState([])
    const [visibleItems, setVisibleItems] = useState(10);

    const [isFiltered, setIsFiltered] = useState(false)

    const [tab, setTab] = useState(0)

    // Reset des cartons jaunes
    const yellowCardSoccerPlayers = []

    useEffect(() => {
        const handle = () => {
            window.parentIFrame?.sendMessage({ type: 'scrollToTopReady' });
        };

        if (document.readyState === 'complete') {
            handle();
        } else {
            window.addEventListener('load', handle);
            return () => window.removeEventListener('load', handle);
        }
    }, [])

    useEffect(() => {

        if(!match.isComplete)
            return

        const getPlayer = (id) => getPlayerById(id, match);

          let buildGameFacts = match.gameFacts
            .sort((a, b) => {
                if (a.detail.period < b.detail.period) {
                    return -1;
                } else if (a.detail.period > b.detail.period) {
                    return 1;
                } else {
                    return a.detail.timer - b.detail.timer;
                }
            })

            // Perfectionner le rendu generique et apports des modifs sur le model
            buildGameFacts = buildGameFacts.map(gf => {
                switch(gf.type){
                    case GAME_FACT_SOCCER_SHOT : 
                        return {...gf, detail : {...gf.detail, player : gf.detail.shoter}}
                    case GAME_FACT_SOCCER_YELLOWCARD : 
                        if(gf.detail.player && yellowCardSoccerPlayers.includes(gf.detail.player+gf.detail.team)){
                            var player = getPlayer(gf.detail.player)
                            var reasonInfo = reasonListSoccer.find(r => r.id === gf.detail.reason)
                            let title = "CARTON ROUGE"
                            let text = gf.detail?.text ? gf.detail.text : `2eme carton jaune pour ${player.lastname}! ${reasonInfo ? 'Raison: '+reasonInfo.value +'.' : ''} C'est donc un carton rouge pour ${player.lastname} !`
                            // 2eme jaune
                            return {...gf, type : GAME_FACT_SOCCER_SECONDYELLOWCARD, detail : {...gf.detail, title, text}}
                        }else{
                            yellowCardSoccerPlayers.push(gf.detail.player+gf.detail.team)
                            return {...gf}
                        }
                    default : 
                        return {...gf}
                }

            })

            let buildQuestionBox = match.questionBoxes ? match.questionBoxes.map(i => ({...i, type : 'questionBox'})) : []
            let buildMedias = match.quizzs ? match.quizzs.map(i => ({...i, type : 'quizz'})) : []
            let buildSurveys = match.surveys ? match.surveys.map(i => ({...i, type : 'survey'})) : []
            let buildNotations = match.notations ? match.notations.map(i => ({...i, type : 'notation'})) : []
            let buildArticles = match.articles ? match.articles.map(i => ({...i, type : 'article'})) : []

            const sortThings = (a, b) => {
                            const getTimer = (obj) => (obj.detail ? obj.detail.timer : obj.timer)
                            const getPeriod = (obj) => (obj.detail ? obj.detail.period : obj.period)
            
                            const aTimer = getTimer(a)
                            const bTimer = getTimer(b)
            
                            const aPeriod = getPeriod(a)
                            const bPeriod = getPeriod(b)
            
                            const isOpta = (obj) =>
                                obj?.thirdPartyId === 'opta' ||
                                obj?.detail?.thirdPartyId === 'opta'
            
                            const bothOpta = isOpta(a) && isOpta(b)
            
                            const hasNumericTimer = (t) =>
                                typeof t === 'number' && !Number.isNaN(t)
            
                            // --- CAS SPÉCIFIQUE OPTA ---
                            // période : DÉCROISSANT
                            // timer (si même période) : DÉCROISSANT
                            if (bothOpta && hasNumericTimer(aTimer) && hasNumericTimer(bTimer)) {
                                // 1) comparer la période (décroissant → plus grande d'abord)
                                if (aPeriod !== undefined && bPeriod !== undefined && aPeriod !== bPeriod) {
                                return aPeriod > bPeriod ? -1 : 1
                                }
            
                                // 2) même période → comparer les timers (décroissant)
                                const aFullTimer = a.detail
                                ? getNumericTimer(a.detail.timer, a.detail.period, match.discipline)
                                : getMediaNumericTimer(a.timer, a.period, match.discipline)
            
                                const bFullTimer = b.detail
                                ? getNumericTimer(b.detail.timer, b.detail.period, match.discipline)
                                : getMediaNumericTimer(b.timer, b.period, match.discipline)
            
                                if (aFullTimer !== bFullTimer) {
                                // DÉCROISSANT sur le timer
                                return aFullTimer > bFullTimer ? -1 : 1
                                }
            
                                // 3) fallback sur les dates (comme avant)
                                const getDisplayDate = (obj) =>
                                new Date(obj?.detail?.displayDate ?? obj?.displayDate ?? obj?.creation)
            
                                const getCreationDate = (obj) => new Date(obj?.creation)
            
                                const bDisplayDate = getDisplayDate(b)
                                const aDisplayDate = getDisplayDate(a)
            
                                if (bDisplayDate < aDisplayDate) return -1
                                if (bDisplayDate > aDisplayDate) return 1
            
                                const bCreation = getCreationDate(b)
                                const aCreation = getCreationDate(a)
            
                                if (bCreation < aCreation) return -1
                                if (bCreation > aCreation) return 1
            
                                return 0
                            }
                            // --- LOGIQUE CLASSIQUE ---
            
                            if (bTimer === 0 || aTimer === 0) {
                                const getDisplayDate = (obj) =>
                                new Date(obj?.detail?.displayDate ?? obj?.displayDate ?? obj?.creation)
            
                                const getCreationDate = (obj) => new Date(obj?.creation)
            
                                const bDisplayDate = getDisplayDate(b)
                                const aDisplayDate = getDisplayDate(a)
            
                                if (bDisplayDate < aDisplayDate) return -1
                                if (bDisplayDate > aDisplayDate) return 1
            
                                const bCreationDate = getCreationDate(b)
                                const aCreationDate = getCreationDate(a)
            
                                if (bCreationDate < aCreationDate) return -1
                                if (bCreationDate > aCreationDate) return 1
            
                                return 0
                            }
            
                            const bFullTimer = b.detail
                                ? getNumericTimer(b.detail.timer, b.detail.period, match.discipline)
                                : getMediaNumericTimer(b.timer, b.period, match.discipline)
            
                            const aFullTimer = a.detail
                                ? getNumericTimer(a.detail.timer, a.detail.period, match.discipline)
                                : getMediaNumericTimer(a.timer, a.period, match.discipline)
            
                            if (bFullTimer < aFullTimer) {
                                if (bPeriod > aPeriod) return 1
                                return -1
                            }
                            if (bFullTimer > aFullTimer) {
                                if (bPeriod < aPeriod) return -1
                                return 1
                            }
            
                            const bCreation = new Date(b.creation)
                            const aCreation = new Date(a.creation)
            
                            if (bCreation < aCreation) return -1
                            if (bCreation > aCreation) return 1
            
                            return 0
                            }
            
                        setPinItems(buildQuestionBox.filter(g => g.isPin).concat(buildMedias.filter(g => g.isPin)).concat(buildSurveys.filter(g => g.isPin)).concat(buildNotations.filter(g => g.isPin)).concat(buildArticles.filter(g => g.isPin)).sort(sortThings))
            
                        setItems((buildGameFacts.concat(buildQuestionBox.filter(g => !g.isPin)).concat(buildMedias.filter(g => !g.isPin)).concat(buildSurveys.filter(g => !g.isPin)).concat(buildNotations.filter(g => !g.isPin)).concat(buildArticles.filter(g => !g.isPin))).sort(sortThings))
                }, [match])

    const handleShowMore = async () => {

        if(match.hasMore)
            await loadMore()

        const newVisibleItems = visibleItems + 10;
        setVisibleItems(newVisibleItems);
    };

    const disabledShowMore = useMemo(() => {
        return visibleItems >= items.length
        && !match.hasMore
    }, [match.hasMore, visibleItems, items])

    const postFilter = useCallback((items) => {
        if(isFiltered){
            return items.filter(i => [
                GAME_FACT_SOCCER_PENALTY,
                GAME_FACT_SOCCER_BUT,

                GAME_FACT_ESSAI, 
                GAME_FACT_TRANSFORMATION, 
                GAME_FACT_PENALITE, 
                GAME_FACT_DROP,

                GAME_FACT_BASKET_FREETHROW,
                GAME_FACT_BASKET_TWOPOINTS,
                GAME_FACT_BASKET_THREEPOINTS,

                GAME_FACT_HANDBALL_GOAL,
                GAME_FACT_HANDBALL_PENALTY
            ].includes(i.type))
        }

        return items
    }, [isFiltered])

    // TODO NO LOAD
    if(!match.isComplete)
        return <CircularProgress/>

    return (
        <Box>
             {/* Bouton custom en haut si demandé */}
                    {redirectUrlFromUrl && displayTextFromUrl && buttonPositionFromUrl === 'top' && (
                        <CustomRedirectButton
                        redirectUrl={redirectUrlFromUrl}
                        displayText={displayTextFromUrl}
                        />
                    )}
            <Box sx={{display : 'flex', flexDirection : 'column', alignItems:'center', textAlign : 'center', marginBottom : 3, position : 'relative'}}>
                <Box sx={{position : 'fixed', width : '100%',  zIndex : 1000}}>
                    <Button variant={'contained'} onClick={() => navigate(-1)} sx={{float : 'left', ml : 5}}>&#x3008;
                    
                    </Button>
                </Box>
                {match.type==='match' && <MatchHeader match={match}/>}
            </Box>
    
            <Box sx={{ borderBottom: 1, borderTop : 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)} aria-label="basic tabs example" centered>
                     <Tab label="Live" {...a11yProps(0)} />
                    <Tab label="Composition" {...a11yProps(1)} />
                </Tabs>
            </Box>
    
            <TabPanel value={tab} index={0}>
                <Box textAlign={"center"}>
                    <Button
                        onClick={() => setIsFiltered((s) => !s)}
                        variant="outlined"
                        sx={{
                            mb : 3,
                            color: '#4A5168', // bleu foncé
                            borderColor: '#4A5168',
                            borderRadius: '999px',
                            textTransform: 'none',
                            fontWeight: 500,
                            padding: '6px 16px',
                            '&:hover': {
                            borderColor: '#4970B5',
                            color : '#4970B5'
                            },
                        }}
                        startIcon={<FontAwesomeIcon icon={faEye} />}
                        >
                        {isFiltered ? 'Tout afficher' : 'Afficher les buts'}
                    </Button>
                </Box>
                <Box className='medium-padding'></Box>
                {pinItems.length>0 && <Stack spacing={0}>
                    {postFilter(pinItems).map((t, idx) =>
                        <React.Fragment key={t._id}>
                            <ItemResolver item={t} match={match} />
                        </React.Fragment>
                    )}
                    <CustomDivider/>
                </Stack>}
                <Stack spacing={0}>
                {postFilter(items).slice(0, visibleItems).map((t, idx) => 
                    <React.Fragment key={t._id}>
                        <ItemResolver item={t} match={match} />
                        <CustomDivider disabled={true}/>
                    </React.Fragment>
                )}
                </Stack>
                {!disabledShowMore ? (
                    <Button sx={{width : '100%', mt : 5, bgcolor : "multiplex.darkblue"}} onClick={handleShowMore} variant="contained">
                    Voir plus
                    </Button>
                ) : (
                    <Button sx={{width : '100%', mt : 5}} variant="contained" disabled>
                    Début du direct
                    </Button>
                )}
            </TabPanel>
            {match.type==='match' && <TabPanel value={tab} index={1}>
                <CompositionPreview match={match}/>
            </TabPanel>}
        
        {/* Bouton custom en bas si demandé */}
                {redirectUrlFromUrl && displayTextFromUrl && buttonPositionFromUrl === 'bottom' && (
                    <CustomRedirectButton
                    redirectUrl={redirectUrlFromUrl}
                    displayText={displayTextFromUrl}
                    />
                )}

        </Box>

        )

}

const CustomRedirectButton = ({ redirectUrl, displayText }) => {
  if (!redirectUrl) return null;

  let finalUrl = redirectUrl.trim();

  // Si l'URL ne commence pas par http:// ou https://, on ajoute https://
  if (!/^https?:\/\//i.test(finalUrl)) {
    finalUrl = 'https://' + finalUrl;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
      <Button
        variant="contained"
        onClick={() => window.open(finalUrl, '_blank', 'noopener,noreferrer')}
        sx={{
          borderRadius: '20px',
          textTransform: 'none',
          px: 3,
          py: 0.8,
          fontWeight: 300,
        }}
      >
        {displayText}
      </Button>
    </Box>
  );
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ paddingTop: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
  }

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export default MatchView